import { makeStyles } from "@material-ui/core/styles";
import { colors } from "~/utils/colors";

const { background } = colors;

export default makeStyles((theme) => ({
	"@keyframes slideUp": {
		from: {
			transform: "translateY(100%)",
			opacity: 0,
		},
		to: {
			transform: "translateY(0)",
			opacity: 1,
		},
	},
	overlay: {
		position: "fixed",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		zIndex: 1400,
		display: "flex",
		alignItems: "flex-end",
		justifyContent: "center",
		paddingBottom: 0,
	},
	modal: {
		position: "relative",
		width: "100%",
		maxWidth: 480,
		backgroundColor: background?.default || "#FDFCF8",
		borderTopLeftRadius: 30,
		borderTopRightRadius: 30,
		padding: "20px",
		paddingBottom: "24px",
		boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.2)",
		animation: "$slideUp 0.4s ease-out",
		overflowY: "auto",
	},
	title: {
		textAlign: "center",
		paddingBottom: "10px",
		position: "relative",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		marginBottom: "10px",
	},
	closeButton: {
		position: "absolute",
		right: 0,
		top: "50%",
		transform: "translateY(-50%)",
		padding: "8px",
		color: "#666",
	},
	content: {
		padding: "20px 0",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	actions: {
		display: "flex",
		gap: "10px",
		padding: "10px 0",
		marginTop: "10px",
	},
	button: {
		flex: 1,
		height: "44px",
		borderRadius: "20px",
		textTransform: "none",
		fontWeight: "500",
	},
}));

